<template>
  <div class="container">
    <div class="row align-items-center mb-3">
      <div class="col-md-6 offset-md-3">
        <h2 class="text-center">{{headline}}</h2>
      </div>

      <div v-if="users.length > 1" class="col-md-3">
        <h5>Filtrera på användare</h5>
        <v-select
          :options="users"
          label="name"
          v-model="selectedUser"
        >
          <template #search="{attributes, events}">
            <input
              class="vs__search"
              v-bind="attributes"
              v-on="events"
            />
          </template>
        </v-select>
      </div>
    </div>

    <stats-dashboard :user-id="userIdForStats" />
  </div>
</template>

<style scoped>
</style>

<script setup lang="ts">
import { computed, ref } from 'vue';
interface User { id: number; name: string }
const props = defineProps<{ users: User[] }>();
const selectedUser = ref<User | null>(props.users.length === 1 ? props.users[0] : null);
const headline = computed(() => selectedUser.value ? `Säljstatistik för ${selectedUser.value.name}` : 'Säljstatistik för hela bolaget');
const userIdForStats = computed(() => selectedUser.value?.id ?? null);
</script>
